import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
// Self-hosted fonts + icons. The CDN approach (preload from
// fonts.googleapis.com / cdnjs.cloudflare.com) is blocked by the
// CloudFront CSP `style-src 'self' 'unsafe-inline'`. Bundling them
// keeps everything same-origin and removes the network dependency
// on cold load. requirements/ui-patterns.md still specifies Inter +
// Font Awesome 6.5 — only the delivery path changed.
import "@fontsource/inter/300.css";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
// Only fa-solid is used in this app; importing core + solid keeps the CSS
// payload to ~30 KB instead of ~98 KB (skip regular + brands families).
import "@fortawesome/fontawesome-free/css/fontawesome.min.css";
import "@fortawesome/fontawesome-free/css/solid.min.css";
import { App } from "./App";
import "./styles/global.css";

const root = document.getElementById("root");
if (!root) throw new Error("Root element not found");
createRoot(root).render(
    <StrictMode>
        <App />
    </StrictMode>,
);
